import { itineraryPath, quickEditPath } from '../QuickEdit/paths'

/** Where the create-event flow was opened from, and so where it goes back to. */
export type EventCreateOrigin = 'itinerary' | 'quickEdit'

/** Router state the flow reads to know where to return; the itinerary when absent. */
export interface EventCreateLocationState {
	from?: EventCreateOrigin
}

export const EVENT_CREATE_ROUTE = '/trips/:tripId/itinerary/new-event'

/**
 * The create-event flow for a trip, preselecting a Trip day (zero-based;
 * `?day=` is 1-based, as on the itinerary) and prefilled from an idea when one
 * is given.
 */
export const newEventPath = (tripId: string | number, dayIndex: number, ideaId?: number): string =>
	`/trips/${tripId}/itinerary/new-event?day=${dayIndex + 1}${ideaId === undefined ? '' : `&idea=${ideaId}`}`

/** Back where the flow came from, on the given day: the new event's once created, the opening one on close. */
export const eventCreateReturnPath = (
	tripId: string | number,
	from: EventCreateOrigin | undefined,
	dayIndex: number,
): string => (from === 'quickEdit' ? quickEditPath(tripId, dayIndex) : itineraryPath(tripId, dayIndex))

/** Parses the flow's `?idea=`, or null when absent or malformed. */
export const ideaIdFromParam = (param: string | null): number | null =>
	param !== null && /^\d+$/.test(param) ? Number(param) : null
